<template>
  <v-container id="login" class="fill-height justify-center" tag="section">
    <v-row justify="center">
      <v-slide-y-transition appear>
        <base-material-card
          color="primary"
          light
          max-width="100%"
          width="400"
          class="px-5 py-3"
        >
          <template v-slot:heading>
            <div class="text-center">
              <h1 class="display-2 font-weight-bold mb-2">Login</h1>
            </div>
          </template>
          <v-card-text class="text-center">
            <div class="text-center grey--text h-1 font-weight-light">
              Bienvenidos IoT sensors
            </div>
            <v-text-field
              color="secondary"
              v-model="email"
              label="Email"
              prepend-icon="mdi-face"
              class="mt-10"
              required
            />
            <v-text-field
              class="mb-8"
              v-model="password"
              type="password"
              color="secondary"
              label="Password"
              prepend-icon="mdi-lock-outline"
              required
            />

            <v-flex class="red--text" v-if="error">{{ error }}</v-flex>
            <pages-btn
              @click="loader = 'loading', ingresar()"
              large
              :loading="loading"
              :disabled="loading"
            >
              Ingresar
            </pages-btn>
         
            <v-spacer></v-spacer>
            <pages-btn :to="{ name: 'Crear Usuario' }" small color="error">
              Crear nuevo usuario
            </pages-btn>
            <v-spacer></v-spacer>
            <pages-btn
              :to="{ name: 'Olvide Contrasena' }"
              small
              color="warning"
            >
              Olvidé mi contraseña
            </pages-btn>
          </v-card-text>
        </base-material-card>
      </v-slide-y-transition>
    </v-row>
  </v-container>
</template>

<script >
import axios from "axios";
export default {
  name: "PagesLogin",

  components: {
    PagesBtn: () => import("./components/Btn"),
  },
  data() {
    return {
      email: "",
      password: "",
      error: null,
      loader: null,
      loading: false,
    };
  },
  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];
      this.loader = null;
    },
  },

  methods: {
    ingresar() {
      this.error = null;
      axios
        .post("api/Users/Login", {
          email: this.email,
          password: this.password,
        })
        .then((respuesta) => {
          return respuesta.data;
        })
        .then((data) => {
          console.log("login !!");
          console.log(data.token);
          localStorage.setItem("email", this.email);
          this.$store.dispatch("guardarToken", data.token);
          this.$router.push({ name: "Dashboard" });
        })
        .catch((err) => {
          this.loading=false;
          //console.log(err.response);
          if (err.response.status == 400) {
            this.error = "Invalid email or password";
          } else if (err.response.status == 404) {
            this.error = "Invalid email or password";
          } else {
            this.error = "Ocurrió un error";
          }
          //console.log(err)
        });
    },
  },
};
</script>
